/* ============================================================
   QUELL — theme behaviours
   Chrome (header / footer / search overlay) is server-rendered
   Liquid; this file only wires up interactions: quote list
   (PDP add button + quote page selection panel), predictive
   search overlay, mobile nav, scroll reveals, FAQ accordion,
   stat count-up, image fallback.
   ============================================================ */
(function () {
  "use strict";

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  /* ── Quote list ────────────────────────────────────────────── */
  var QUOTE_KEY = "quell_quote_v1";

  function quoteRead() {
    try {
      var a = JSON.parse(localStorage.getItem(QUOTE_KEY));
      return Array.isArray(a) ? a : [];
    } catch (e) {
      return [];
    }
  }
  function quoteWrite(items) {
    try {
      localStorage.setItem(QUOTE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  theme.quote = { read: quoteRead, write: quoteWrite, KEY: QUOTE_KEY };
  window.theme = theme;

  function initQuoteAdd(root) {
    (root || document)
      .querySelectorAll("[data-quote-add]")
      .forEach(function (btn) {
        var scope = btn.closest(".shopify-section") || document;

        function selection() {
          var sw = scope.querySelector(".sw-btn.on");
          var colour = (sw && sw.getAttribute("data-name")) || "";
          var spec = btn.getAttribute("data-spec") || colour;
          var priceEl = scope.querySelector("#price");
          return {
            key: [btn.getAttribute("data-key"), spec].join("|"),
            title: btn.getAttribute("data-title") || "",
            spec: spec,
            price:
              (priceEl && priceEl.textContent.trim()) ||
              btn.getAttribute("data-price") ||
              "",
            image: btn.getAttribute("data-image") || "",
            url: btn.getAttribute("data-url") || "",
            qty: 1,
          };
        }

        btn.addEventListener("click", function () {
          var item = selection();
          var items = quoteRead();
          // Re-adding the same variant (identical key) bumps its quantity;
          // a different colour/variant has a different key and stays a new line.
          var existing = null;
          for (var i = 0; i < items.length; i++) {
            if (items[i].key === item.key) {
              existing = items[i];
              break;
            }
          }
          if (existing) {
            existing.qty = (parseInt(existing.qty, 10) || 1) + 1;
          } else {
            items.push(item);
          }
          quoteWrite(items);
          window.location.href =
            btn.getAttribute("data-quote-url") || "/pages/quote";
        });
      });
  }

  function initQuoteSetting(root) {
    (root || document)
      .querySelectorAll("[data-quote-setting]")
      .forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          var scope = btn.closest(".setting") || document;
          var nodes = scope.querySelectorAll("[data-qp]");
          var url =
            btn.getAttribute("data-quote-url") || "/pages/quote";
          if (nodes.length) {
            e.preventDefault();
            var items = quoteRead();
            nodes.forEach(function (el) {
              var item = {
                key: (el.getAttribute("data-key") || "") + "|",
                title: el.getAttribute("data-title") || "",
                spec: "",
                price: el.getAttribute("data-price") || "",
                image: el.getAttribute("data-image") || "",
                url: el.getAttribute("data-url") || "",
                qty: 1,
              };
              var exists = items.some(function (it) {
                return it.key === item.key;
              });
              if (!exists) items.push(item);
            });
            quoteWrite(items);
            window.location.href = url;
          }
        });
      });
  }

  function initQuotePage() {
    if (document.querySelector("[data-quote-done]")) {
      quoteWrite([]);
      return;
    }
    var wrap = document.querySelector("[data-quote-lines]");
    if (!wrap) return;
    var symbol = wrap.getAttribute("data-currency") || "£";
    var emptyHtml = wrap.innerHTML;
    var countEl = document.querySelector("[data-quote-count]");
    var unitsEl = document.querySelector("[data-quote-units]");
    var totalEl = document.querySelector("[data-quote-total]");
    var fieldEl = document.querySelector("[data-quote-products]");
    var totalFallback = totalEl ? totalEl.textContent : "";

    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    // Drop raw hex colour codes (e.g. "#615f5d") from a stored spec string, so
    // quote lines saved before the PDP fix — and the submitted payload — never
    // expose them. Mirrors the strip in section-product-main.js. QUELL-194.
    function specClean(spec) {
      return String(spec == null ? "" : spec)
        .split(" · ")
        .filter(function (part) {
          return !/^#[0-9a-f]{3,8}$/i.test(part.trim());
        })
        .join(" · ");
    }

    function lineHtml(it) {
      var spec = specClean(it.spec);
      var th = it.image
        ? '<img src="' +
          esc(it.image) +
          '" alt="' +
          esc(it.title) +
          '" loading="lazy">'
        : '<span class="mono">' +
          esc((it.title || "?").slice(0, 2).toUpperCase()) +
          "</span>";
      var name = it.url
        ? '<a href="' + esc(it.url) + '">' + esc(it.title) + "</a>"
        : esc(it.title);
      return (
        '<div class="line" data-key="' +
        esc(it.key) +
        '"><div class="th">' +
        th +
        '</div><div><div class="ln">' +
        name +
        "</div>" +
        (spec ? '<div class="lc">' + esc(spec) + "</div>" : "") +
        (it.price ? '<div class="lp">' + esc(it.price) + "</div>" : "") +
        '</div><div class="right"><div class="stepper">' +
        '<button type="button" data-step="-1" aria-label="' +
        esc(strings.quoteDecrease || "Decrease quantity") +
        '">&minus;</button>' +
        '<span class="q">' +
        (parseInt(it.qty, 10) || 1) +
        "</span>" +
        '<button type="button" data-step="1" aria-label="' +
        esc(strings.quoteIncrease || "Increase quantity") +
        '">+</button>' +
        '</div><button type="button" class="rm" data-remove>' +
        esc(strings.quoteRemove || "Remove") +
        "</button></div></div>"
      );
    }

    function render() {
      var items = quoteRead();
      wrap.innerHTML = items.length ? items.map(lineHtml).join("") : emptyHtml;

      if (countEl)
        countEl.textContent =
          items.length +
          " " +
          (items.length === 1
            ? strings.quoteLineOne || "line"
            : strings.quoteLineOther || "lines");

      var units = 0,
        total = 0,
        priced = false;
      items.forEach(function (it) {
        var q = parseInt(it.qty, 10) || 1;
        units += q;
        var n = parseFloat(String(it.price || "").replace(/[^0-9.]/g, ""));
        if (n > 0) {
          total += n * q;
          priced = true;
        }
      });

      if (unitsEl)
        unitsEl.textContent =
          units +
          " " +
          (units === 1
            ? strings.quoteUnitOne || "unit"
            : strings.quoteUnitOther || "units");
      if (totalEl)
        totalEl.textContent = priced
          ? symbol + total.toLocaleString("en-GB", { maximumFractionDigits: 2 })
          : totalFallback;

      if (fieldEl)
        fieldEl.value = items
          .map(function (it) {
            var spec = specClean(it.spec);
            return (
              (parseInt(it.qty, 10) || 1) +
              " × " +
              it.title +
              (spec ? " (" + spec + ")" : "") +
              (it.price ? " — " + it.price + " each" : "") +
              (it.url ? " — " + window.location.origin + it.url : "")
            );
          })
          .join("\n");
    }

    wrap.addEventListener("click", function (e) {
      var line = e.target.closest("[data-key]");
      if (!line) return;
      var key = line.getAttribute("data-key");
      var items = quoteRead();
      var stepBtn = e.target.closest("[data-step]");
      if (stepBtn) {
        var step = parseInt(stepBtn.getAttribute("data-step"), 10) || 0;
        items.forEach(function (it) {
          if (it.key === key)
            it.qty = Math.max(1, (parseInt(it.qty, 10) || 1) + step);
        });
      } else if (e.target.closest("[data-remove]")) {
        items = items.filter(function (it) {
          return it.key !== key;
        });
      } else {
        return;
      }
      quoteWrite(items);
      render();
    });

    render();
  }

  /* ── Predictive search overlay ─────────────────────────────── */
  function initSearch() {
    var sx = document.getElementById("searchOverlay");
    if (!sx) return;
    var input = sx.querySelector("#sxInput");
    var results = sx.querySelector("#sxResults");
    var popular = sx.querySelector("#sxPopular");
    var live = sx.querySelector("#sxLive");
    var active = -1,
      items = [],
      timer = null,
      lastQ = null;
    var base =
      routes.predictiveSearchUrl ||
      (routes.searchUrl || "/search") + "/suggest";

    function open() {
      sx.hidden = false;
      requestAnimationFrame(function () {
        sx.classList.add("open");
      });
      document.body.style.overflow = "hidden";
      input.value = "";
      lastQ = null;
      showPopular();
      setTimeout(function () {
        input.focus();
      }, 60);
    }
    function close() {
      sx.classList.remove("open");
      document.body.style.overflow = "";
      setTimeout(function () {
        sx.hidden = true;
      }, 280);
    }
    function setItems(scope) {
      items = scope ? scope.querySelectorAll(".sx-item") : [];
      active = -1;
    }
    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i];
        a[i] = a[j];
        a[j] = t;
      }
      return a;
    }
    function showPopular() {
      live.innerHTML = "";
      active = -1;
      if (!popular) {
        items = [];
        return;
      }
      popular.hidden = false;
      var pool = popular.querySelector("#sxPopPool");
      if (pool) {
        // Random 4 each open; the quote row lives outside the pool, so it stays pinned last.
        var all = Array.prototype.slice.call(pool.children);
        var seen = {};
        var uniq = [];
        all.forEach(function (el) {
          el.style.display = "none";
          var href = el.getAttribute("href");
          if (!seen[href]) {
            seen[href] = 1;
            uniq.push(el);
          }
        });
        shuffle(uniq);
        uniq.slice(0, 4).forEach(function (el) {
          el.style.display = "";
        });
      }
      items = Array.prototype.filter.call(
        popular.querySelectorAll(".sx-item"),
        function (el) {
          return el.style.display !== "none";
        },
      );
    }

    function fetchResults(q) {
      var url =
        base +
        "?q=" +
        encodeURIComponent(q) +
        "&section_id=predictive-search&resources[type]=product,page&resources[limit]=10&resources[options][unavailable_products]=last";
      fetch(url, { headers: { Accept: "text/html" } })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          if (q !== lastQ) return; // stale response
          if (popular) popular.hidden = true;
          live.innerHTML = html;
          setItems(live);
        })
        .catch(function () {
          if (popular) popular.hidden = true;
          live.innerHTML =
            '<div class="sx-empty">' +
            (strings.searchUnavailable || "Search is unavailable right now.") +
            " " +
            '<a href="' +
            (routes.searchUrl || "/search") +
            "?q=" +
            encodeURIComponent(q) +
            '&type=product">' +
            (strings.searchOpenFull || "Open full search →") +
            "</a></div>";
          setItems(live);
        });
    }

    function move(d) {
      if (!items.length) return;
      active = (active + d + items.length) % items.length;
      items.forEach(function (it, k) {
        it.classList.toggle("act", k === active);
      });
      var el = items[active];
      if (el && el.scrollIntoView) el.scrollIntoView({ block: "nearest" });
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (!q) {
        showPopular();
        return;
      }
      timer = setTimeout(function () {
        fetchResults(q);
      }, 180);
    });

    var btn = document.getElementById("btnSearch");
    if (btn) btn.addEventListener("click", open);
    sx.addEventListener("click", function (e) {
      if (e.target.closest("[data-sxclose]")) close();
    });

    document.addEventListener("keydown", function (e) {
      var openCombo =
        e.key === "/" ||
        ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k");
      if (openCombo && sx.hidden) {
        var t = e.target.tagName;
        if (t === "INPUT" || t === "TEXTAREA" || t === "SELECT") return;
        e.preventDefault();
        open();
        return;
      }
      if (sx.hidden) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowDown") {
        e.preventDefault();
        move(1);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        move(-1);
      } else if (e.key === "Enter") {
        var pick = active > -1 ? items[active] : items[0];
        if (pick) window.location.href = pick.getAttribute("href");
      }
    });
  }

  /* ── Mobile nav ────────────────────────────────────────────── */
  function initMobileMenu() {
    var btn = document.getElementById("btnMenu");
    var panel = document.getElementById("mobileNav");
    if (!btn || !panel) return;
    function toggle(force) {
      var openNow =
        typeof force === "boolean" ? force : !panel.classList.contains("open");
      panel.classList.toggle("open", openNow);
      btn.setAttribute("aria-expanded", openNow ? "true" : "false");
      document.body.style.overflow = openNow ? "hidden" : "";
      if (openNow) {
        var closeBtn = panel.querySelector(".qd-x");
        if (closeBtn) closeBtn.focus();
      } else {
        btn.focus();
      }
    }
    btn.addEventListener("click", function () {
      toggle();
    });
    panel.addEventListener("click", function (e) {
      if (e.target.closest("[data-mclose]") || e.target.closest("a"))
        toggle(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("open")) toggle(false);
    });
    // Drawer search is a launcher, not a field: close the drawer, open the search overlay.
    var searchTrigger = panel.querySelector(".mn-search");
    if (searchTrigger) {
      searchTrigger.addEventListener("click", function () {
        toggle(false);
        var sb = document.getElementById("btnSearch");
        if (sb) sb.click();
      });
    }
  }

  /* ── Scroll reveals (fail-safe: content visible even without JS) ─ */
  function initReveals() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    document.documentElement.classList.add("reveal-ready");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -6% 0px" },
    );
    els.forEach(function (el) {
      io.observe(el);
    });
    setTimeout(function () {
      document.querySelectorAll(".reveal:not(.in)").forEach(function (el) {
        el.classList.add("in");
      });
    }, 1100);
  }

  /* ── FAQ accordion (native <details>, one open per group) ──── */
  function initFaq() {
    document.querySelectorAll(".faq-list").forEach(function (list) {
      list.addEventListener(
        "toggle",
        function (e) {
          var d = e.target;
          if (d.tagName === "DETAILS" && d.open) {
            list.querySelectorAll("details[open]").forEach(function (o) {
              if (o !== d) o.open = false;
            });
          }
        },
        true,
      );
    });
  }

  /* ── Stat count-up ─────────────────────────────────────────── */
  function initCountUp() {
    if (!("IntersectionObserver" in window)) return;
    document.querySelectorAll("[data-count]").forEach(function (el) {
      var target = parseFloat(el.getAttribute("data-count"));
      var suffix = el.getAttribute("data-suffix") || "";
      var io = new IntersectionObserver(
        function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(el);
            var start = null,
              dur = 1100;
            function step(ts) {
              if (!start) start = ts;
              var p = Math.min((ts - start) / dur, 1);
              var e = 1 - Math.pow(1 - p, 3);
              var v = target * e;
              el.textContent =
                (target % 1 ? v.toFixed(1) : Math.round(v)) + suffix;
              if (p < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          });
        },
        { threshold: 0.5 },
      );
      io.observe(el);
    });
  }

  function enforceProductSearch() {
    if (!document.body.classList.contains("template-search")) return;
    var params = new URLSearchParams(location.search);
    if (!params.get("q") || params.get("type") === "product") return;
    params.set("type", "product");
    location.replace(location.pathname + "?" + params.toString());
  }

  function initSearchFacets() {
    var bar = document.getElementById("filterBar");
    if (!bar) return;
    var dropdowns = bar.querySelectorAll(".fdd");

    function closeAll(except) {
      dropdowns.forEach(function (d) {
        if (d !== except) d.removeAttribute("open");
      });
    }

    dropdowns.forEach(function (d) {
      var btn = d.querySelector(".fdd-btn");
      if (!btn) return;
      btn.addEventListener("click", function () {
        setTimeout(function () {
          if (d.hasAttribute("open")) closeAll(d);
        }, 0);
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".fdd")) closeAll(null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll(null);
    });
  }

  // Locale switcher — native <details> localization forms; options submit with no JS,
  // so this only enhances open/close (close others, outside-click, Escape).
  function initLocaleSwitcher() {
    var switchers = document.querySelectorAll("details.locale");
    if (!switchers.length) return;

    function closeAll(except) {
      switchers.forEach(function (d) {
        if (d !== except) d.removeAttribute("open");
      });
    }

    switchers.forEach(function (d) {
      var btn = d.querySelector(".locale-btn");
      if (!btn) return;
      btn.addEventListener("click", function () {
        setTimeout(function () {
          if (d.hasAttribute("open")) closeAll(d);
        }, 0);
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest("details.locale")) closeAll(null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll(null);
    });
  }

  // Resolve the visitor's true country once per session (Shopify browsing_context_suggestions), cached; fail-open null.
  var GEO_COUNTRY_KEY = "quell_geo_country_v1";
  var geoCbs = [];
  var geoResolved = false;
  var geoValue = null;
  function resolveGeoCountry(cb) {
    if (typeof cb === "function") {
      if (geoResolved) {
        cb(geoValue);
      } else {
        geoCbs.push(cb);
      }
    }
    if (resolveGeoCountry.started) return;
    resolveGeoCountry.started = true;

    function done(iso) {
      geoResolved = true;
      geoValue = iso || null;
      var list = geoCbs;
      geoCbs = [];
      for (var i = 0; i < list.length; i++) {
        try {
          list[i](geoValue);
        } catch (e) {}
      }
      // Section-level consumers (e.g. dealer-doc-library's per-market brochure
      // gate) don't want to reach into this IIFE. Broadcast the ISO once so
      // they can re-apply their filters after the initial async lookup lands
      // on the first page of a session.
      try {
        document.dispatchEvent(
          new CustomEvent("quell:geo-ready", { detail: { iso: geoValue } }),
        );
      } catch (e) {}
    }

    var cached = null;
    try {
      cached = sessionStorage.getItem(GEO_COUNTRY_KEY);
    } catch (e) {}
    if (cached) return done(cached);
    if (!window.fetch) return done(null);

    var set = document.querySelector(".locale-set");
    var root = (set && set.getAttribute("data-geo-root")) || "/";
    if (root.slice(-1) !== "/") root += "/";
    fetch(root + "browsing_context_suggestions.json?country%5Benabled%5D=true", {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        var dv = data && data.detected_values;
        var iso = dv && dv.country && dv.country.handle;
        if (iso) {
          try {
            sessionStorage.setItem(GEO_COUNTRY_KEY, iso);
          } catch (e) {}
        }
        done(iso);
      })
      .catch(function (err) {
        console.warn("[geo] detection skipped:", err);
        done(null);
      });
  }

  // Hide country-restricted products (config in anja-geo.liquid) by true country, even after a manual market switch. Fail-safe = show.
  function initGeoGate() {
    var cfg = window.QUELL_GEO_GATE;
    if (!cfg) return;
    resolveGeoCountry(function (iso) {
      if (!iso) return;
      var hide = [];
      for (var h in cfg) {
        if (cfg.hasOwnProperty(h) && cfg[h].indexOf(iso) !== -1) hide.push(h);
      }
      var el = document.documentElement;
      if (hide.length) el.setAttribute("data-geo-hide", hide.join(" "));
      else el.removeAttribute("data-geo-hide");
    });
  }

  ready(function () {
    initQuoteAdd();
    initQuoteSetting();
    initQuotePage();
    initSearch();
    enforceProductSearch();
    initSearchFacets();
    initLocaleSwitcher();
    initGeoGate();
    initMobileMenu();
    initReveals();
    initFaq();
    initCountUp();
  });

  document.addEventListener("shopify:section:load", function (e) {
    initQuoteAdd(e.target);
    initQuoteSetting(e.target);
  });
})();
